"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScoreBreakdown = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const base_react_components_1 = require("@navinc/base-react-components");
const SegmentPill = styled_components_1.default.div.withConfig({ displayName: "reports-SegmentPill", componentId: "reports-r4skm6" }) `
  height: 6px;
  background-color: ${({ bgColor }) => bgColor};
  border-radius: 8px;
`;
const SegmentPiece = styled_components_1.default.li.withConfig({ displayName: "reports-SegmentPiece", componentId: "reports-ixtjk8" }) `
  width: ${({ width }) => width};
  list-style-type: none;
  display: grid;
  grid-gap: 4px;
`;
const BreakdownBar = styled_components_1.default.ul.withConfig({ displayName: "reports-BreakdownBar", componentId: "reports-uctuk5" }) `
  padding: 0;
  display: flex;

  & > ${SegmentPiece} {
    margin-right: 4px;
  }
`;
const Legend = styled_components_1.default.ul.withConfig({ displayName: "reports-Legend", componentId: "reports-1u9k5ht" }) `
  display: grid;
  grid-gap: 16px;
  padding: 0;

  @media (${base_react_components_1.theme.forLargerThanPhone}) {
    grid-gap: 24px;
    grid-template-columns: 1fr 1fr;
    grid-auto-flow: column;
  }
`;
const BreakdownWrapper = styled_components_1.default.div.withConfig({ displayName: "reports-BreakdownWrapper", componentId: "reports-1n9rcv9" }) `
  display: grid;
  grid-gap: 16px;

  & > ${BreakdownBar} {
    margin: 0;
  }
`;
const LegendDescription = (0, styled_components_1.default)(base_react_components_1.Copy).attrs(() => ({ size: 'sm' })).withConfig({ displayName: "reports-LegendDescription", componentId: "reports-1a4ovbl" }) `
  grid-column: 2 / -1;
`;
const LegendDot = styled_components_1.default.div.withConfig({ displayName: "reports-LegendDot", componentId: "reports-1uym5c5" }) `
  height: 8px;
  background-color: ${({ bgColor }) => bgColor};
  border-radius: 50%;
`;
const LegendWrapper = styled_components_1.default.li.withConfig({ displayName: "reports-LegendWrapper", componentId: "reports-pvrj1t" }) `
  display: grid;
  grid-template-columns: 8px 1fr;
  grid-column-gap: 8px;
  align-items: center;
`;
/**
 * The ScoreBreakdown component receives a breakdown of sectioned buckets, "bits" into which a score can fall,
 * along with a legend that maps each bit to its description.
 */
const ScoreBreakdown = ({ segmentBreakdown, legendBreakdown, }) => (react_1.default.createElement(BreakdownWrapper, null,
    react_1.default.createElement(BreakdownBar, null, segmentBreakdown.map(({ percent, label, color }, i) => (react_1.default.createElement(SegmentPiece, { key: `${label}${i}`, width: percent !== null && percent !== void 0 ? percent : label },
        react_1.default.createElement(base_react_components_1.Copy, { bold: true, size: "sm" }, label),
        react_1.default.createElement(SegmentPill, { bgColor: color }))))),
    !!segmentBreakdown.length && (react_1.default.createElement(Legend, null, segmentBreakdown.map(({ percent, label, color }, i) => (react_1.default.createElement(LegendWrapper, { key: `${label}${i}` },
        react_1.default.createElement(LegendDot, { bgColor: color }),
        react_1.default.createElement(base_react_components_1.Copy, { bold: true }, percent && label ? `${percent} ${label}` : label),
        react_1.default.createElement(LegendDescription, null, legendBreakdown[i]))))))));
exports.ScoreBreakdown = ScoreBreakdown;
exports.default = (0, styled_components_1.default)(exports.ScoreBreakdown).withConfig({ componentId: "reports-3opg6l" }) ``;
//# sourceMappingURL=index.js.map